import {
  Actions,
  IConditions,
  SubjectType,
  Subjects,
  ActionType,
} from '@efexteam/permission-manager';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import ChecklistIcon from '@mui/icons-material/Checklist';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PaymentIcon from '@mui/icons-material/Payment';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import ACCOUNT_TABS from '@pages/myAccounts/TabsValues';
import {
  icon_building_user,
  icon_chart,
  icon_money_check_dollar,
} from '../../assets';

export type AppSection =
  | 'dashboard'
  | 'receivables'
  | 'payables'
  | 'clients'
  | 'balances'
  | 'savings'
  | 'security';

interface ISidebarNav {
  link: string;
  section: AppSection;
  icon: string | JSX.Element;
  title?: string;
  subLinks?: ISidebarSubNav[];
}

export interface ISidebarSubNav {
  link: string;
  section: string;
  icon: string | JSX.Element;
  classNames?: string;
}

export const sidebarUserNav = (
  can: (
    action: ActionType,
    subject: SubjectType,
    conditions?: IConditions
  ) => boolean
): ISidebarNav[] =>
  [
    {
      link: '/dashboard',
      section: 'dashboard',
      icon: icon_chart,
    },
    {
      link: '/receivables',
      section: 'receivables',
      icon: icon_money_check_dollar,
      title: 'receivablesSubmenuTitle',
    },
    {
      link: '/payables',
      section: 'payables',
      icon: icon_money_check_dollar,
      title: 'payablesSubmenuTitle',
      subLinks: [
        {
          link: `/payables?tab=processing`,
          section: 'proccesingPayment',
          icon: <PaymentIcon fontSize="small" className="mr-1" />,
        },
        can(Actions.CREATE, Subjects.BULK_PAYMENTS)
          ? {
              link: `/payables?tab=bulks`,
              section: 'bulkPayments',
              icon: <ChecklistIcon fontSize="small" className="mr-1" />,
            }
          : null,
      ].filter(Boolean) as ISidebarSubNav[],
    },
    {
      link: '/clients',
      section: 'clients',
      icon: icon_building_user,
    },
    {
      link: '/balances',
      section: 'balances',
      icon: icon_building_user,
      subLinks: [
        {
          link: `/balances?tab=${ACCOUNT_TABS[0]}`,
          section: ACCOUNT_TABS[0],
          icon: <CalculateOutlinedIcon fontSize="small" className="mr-1" />,
        },
        {
          link: `/balances?tab=${ACCOUNT_TABS[1]}`,
          section: ACCOUNT_TABS[1],
          icon: <SavingsOutlinedIcon fontSize="small" className="mr-1" />,
        },
      ],
    },
    can(Actions.MANAGE, Subjects.ACCOUNT)
      ? {
          link: '/security',
          section: 'security',
          icon: <LockOpenIcon sx={{ fill: '#2A4E96' }} />,
        }
      : null,
  ].filter(Boolean) as ISidebarNav[];
